import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import {
    readAssessmentQuestionFocusParams,
    resolveLinkedReportCaseId
} from "../helpers/assessmentQuestionFocus";
import PrivacyQuestionnaires from "./questionnaires";

const PrivacyAssessments = (props) => {
    const {
        softwareData,
        refetchSoftwareData,
        activeAssessment,
        onProgressChange,
        onAssessmentSaved
    } = props;

    const location = useLocation();
    const focusParams = useMemo(() => {
        return readAssessmentQuestionFocusParams(location.search);
    }, [location.search]);
    const linkedReportCaseId = useMemo(() => {
        return resolveLinkedReportCaseId(focusParams);
    }, [focusParams]);

    const [showImpactAssessment, setShowImpactAssessment] = useState(
        !!softwareData?.show_impact_assessment
    );

    const onValidSubmit = useCallback((response) => {
        if (response?.show_impact_assessment !== undefined) {
            setShowImpactAssessment(!!response.show_impact_assessment);
        }

        // Keeps the asset data owned by the details page in sync with the
        // availability returned by the risk assessment.
        refetchSoftwareData && refetchSoftwareData();

        onAssessmentSaved && onAssessmentSaved();
    }, [onAssessmentSaved, refetchSoftwareData])

    /**
     * The impact assessment is unlocked by the risk assessment result, which
     * the details page reports through the asset data.
     */
    useEffect(() => {
        setShowImpactAssessment(!!softwareData?.show_impact_assessment);
    }, [softwareData?.show_impact_assessment]);

    return (
        <PrivacyQuestionnaires
            showImpactAssessment={showImpactAssessment}
            onValidSubmit={onValidSubmit}
            activeAssessment={activeAssessment}
            onProgressChange={onProgressChange}
            reportCaseId={linkedReportCaseId}
            questionFocus={focusParams}
        />
    );
};

export default PrivacyAssessments;
